/*
 * Auth architectural band + legal footer
 * ---------------------------------------------------------------------
 * The altar-frontal appears once, as a bounded band above the form,
 * acting as the sanctuary threshold. It never sits behind the form
 * and is never repeated (Rule 1).
 *
 * The legal footer is kept intentionally quiet, below the card.
 *
 * Named exports are preserved so no auth page imports change.
 * =================================================================== */

const GoogleIcon = () => (
  <svg viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.9 2.4 30.4 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.1C12.4 13.2 17.7 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.1 24.6c0-1.6-.1-3.1-.4-4.6H24v9.1h12.4c-.5 2.9-2.1 5.3-4.6 7l7.1 5.5c4.2-3.9 6.6-9.6 6.6-17z" />
    <path fill="#FBBC05" d="M10.5 28.3c-.5-1.4-.8-2.9-.8-4.3s.3-3 .8-4.3l-7.9-6.1C1 16.7 0 20.2 0 24s1 7.3 2.6 10.4l7.9-6.1z" />
    <path fill="#34A853" d="M24 48c6.4 0 11.9-2.1 15.8-5.8l-7.1-5.5c-2 1.3-4.5 2.1-8.7 2.1-6.3 0-11.6-3.7-13.5-9.1l-7.9 6.1C6.5 42.6 14.6 48 24 48z" />
  </svg>
);

/* Architectural band — one welcoming image at the top of the auth
 * surface. Bounded height, bronze underscore, then parchment. */
export function AuthAside() {
  return <div className="auth-band" role="presentation" aria-hidden="true" data-testid="auth-aside" />;
}

/* Legal footer — quiet meta beneath the card */
export function AuthLegal() {
  return (
    <div className="auth-legal" data-testid="auth-legal">
      <a href="/privacy" data-testid="link-privacy">Privacy</a>
      <span>·</span>
      <a href="/terms" data-testid="link-terms">Terms</a>
      <span>·</span>
      <a href="/cookies" data-testid="link-cookies">Cookies</a>
    </div>
  );
}

/* Retained for backwards compatibility — no other page currently
 * relies on visible content from this component. */
export function AuthTrust() { return null; }

export { GoogleIcon };
